import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthenticationService } from '../../../_services/auth/authentication.service';
import { PenggunaModel } from '../../../_model/auth/authentication.model';
import { CurrentBatasInputanModel, BatasInputanModel } from './batas-inputan.model';
import { environment } from '../../../../environments/environment';
import { SkpdService } from '../skpd.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BatasInputanService {
  skpdId!: string;
  currentOtor!: string;
  tahunAnggaran: any = localStorage.getItem('defaultYear')?.replace(/\D/g, '');
  pengguna: PenggunaModel;

  constructor(
    private httpClient: HttpClient,
    private _authService: AuthenticationService,
    private skpdService: SkpdService,
    private router: Router
  ) {

    this.pengguna = _authService.currentUserDetail;
    this.skpdId = String(skpdService.getCurrentSkpd().id);
    this.currentOtor = this.pengguna.otor;
  }

  updateStatusBySkpd(value: any, idSkpdList: string) {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    params = params.append('idSkpdList', idSkpdList);
    params = params.append('status', value.status);
    params = params.append('tglMulai', value.tglMulai);
    params = params.append('tglAkhir', value.tglAkhir);

    return this.httpClient.get<any>(`${environment.uriApi}/api/lock-skpd/update`, { params });
  }

  getStatusBySkpd() {
    let params = new HttpParams()
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''))
    params = params.append('idSkpd', this.pengguna.skpdId)

    return this.httpClient.get<any>(`${environment.uriApi}/api/lock-skpd/details`, { params, observe: 'response' });
  }

  testUpdateStatusBySkpd() {
    return this.httpClient.get<any>(`${environment.uriApi}/api/lock-skpd/test-update`);
  }

  copyPerubahan(reverse: boolean, belanja: boolean, pendapatan: boolean, pembiayaan: boolean): Observable<any> {
      let params = new HttpParams();
      params = params.append('reverse', reverse ? 'true' : 'false');
      params = params.append('belanja', belanja ? 'true' : 'false');
      params = params.append('pendapatan', pendapatan ? 'true' : 'false');
      params = params.append('pembiayaan', pembiayaan ? 'true' : 'false');
      params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
  
      return this.httpClient.post(`${environment.uriApi}/api/copydata/perubahan`, {}, { params: params, responseType: 'text' as 'json' });
  }
}